<template>
    <div>
        <template v-if="editing">
            <div class="row">
                <div class="col-md-3">
                    <input type="text" class="form-control" v-model="name">
                </div>
                <div class="col-md-2">
                    <button class="btn btn-blue btn-sm" @click="save">Save</button>
                </div>
            </div>
        </template>
        <template v-else>
            {{ name }} <button type="button" @click="editing = true" class="btn btn-xs btn-link">Rename</button>
        </template>
    </div>
</template>

<script>
    import SavedBasket from '../../Services/SavedBasket.js';

    export default {
        props: ['current', 'id'],
        data() {
            return {
                editing: false,
                name: this.current
            }
        },
        methods: {
            save() {
                SavedBasket.rename(this.name, this.id).then(response => {
                    this.editing = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Basket/BasketName.vue